module.exports = __webpack_public_path__ + "img/submit-tx.f2f048da.png";